import script from "./ProductHardCenterEN.vue?vue&type=script&setup=true&name=ProductHardCenterEN&lang=js"
export * from "./ProductHardCenterEN.vue?vue&type=script&setup=true&name=ProductHardCenterEN&lang=js"

import "./ProductHardCenterEN.vue?vue&type=style&index=0&id=21a488e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21a488e0"]])

export default __exports__